import EventBus from '@/utilities/EventBus';
import { defineStore } from 'pinia'

export const useStore = defineStore({  
  id: 'store',
  state: () => (
    {
      isLoading : false,
      // True from the start of the initial data load (reload with an active
      // session) until NavBar + the target View have rendered. Drives the light
      // isotipo splash so it never flickers to the dark overlay mid-load.
      IsInitialLoading : false,
      deviceWidth : 0,
      LoggedUser: null,
      isCustomer: false,
      ReloadErrorMessage: null,
      RequiresMFA: false,
      loadedUsersData: [],
      Organizations: [],
      CurrentOrganizationPK: null,
      JustRegistered: false,
      RegisteredFromLogin: false,
      UserToRegisterData: null,
      unpinnedFiles: [],
      isMobile: false,
      isIpad: false,
      lessThan600: false,
      currentPanel: 0,
      isLoginOrRegister: false,
      Actions: {},
      AssistantEnabled: false,
      GoogleAuthExchange: null,
      toastOptions : {
        position: "top-right",
        timeout: 3000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 1,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      },       

      navigationVars : {
        agreements: {},
        home: {},
        files: {},
        tasks: {},
        agreementsApprovals: {},
        agreementsReadingProcessLog: {},
        users: {},
        organizations: {}
      }
    }
  ),
  actions: {
    SetOrganizations(Organizations){
      this.Organizations = [...Organizations];
    },

    SetLoader(isLoading) {
      this.isLoading = isLoading;
    },

    SetInitialLoading(isInitialLoading) {
      this.IsInitialLoading = isInitialLoading;
    },

    SetGoogleAuthExchange(data) {
      this.GoogleAuthExchange = data;
    },

    SetDeviceWidth(deviceWidth) {
      this.deviceWidth = deviceWidth;

      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      let isIpad = (/Macintosh/i.test(userAgent) || /iPad/i.test(userAgent)) && navigator.maxTouchPoints > 0;
      this.isIpad = isIpad;
    },

    SetLoggedUser(userData){
      // This case is used when the user logs out
      if(userData == null){
        return;
      }
      
      this.LoggedUser = userData;
    },

    SetUserOrganizationData(userOrganizationData) {
      this.Actions = userOrganizationData.Actions;
      this.LoggedUser.Role = userOrganizationData.Role;
      this.unpinnedFiles = userOrganizationData.UnpinnedFiles;
      this.isCustomer = userOrganizationData.Role == 'CUSTOMER';

      EventBus.$emit('SetScreens', userOrganizationData.Screens);
      EventBus.$emit('AssistantEnabledSettingUpdated', userOrganizationData.AssistantEnabled);
    }
  }
})